export const hiddenChatPath = ['/telemed-lobby']
